import React from 'react';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import ReduxForm from '../../../../Components/UI/Form/ReduxForm';
import { formActions } from '../../../../Components/UI/Form/store/forms-reducer';

import Signature from './Signature';
import styles from './ConsentForm.module.css';
import formStyles from '../../../../Components/UI/Form/FormGenerator/FormGenerator.module.css';

/*
"confirmed":null
·         Einwilligungserklärung für Varianteneintragung und Kontaktaufnahme durch uns bei Studienvorschlägen (Häkchen setzen oder ggf. Unterschrift auf Display (wird so bspw. bei GMDB gehandhabt))

"sig_name":"XX"
"sig_first_name":"X"
"sig_date":"2022-08-24"
"sig_place":"Springfield"
"sig_img":"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"
*/

//
//@TODO: Load forms from database
//

const FORMLABEL = 'consent';
const infoText = `## Einverständniserklärung
[Datenschutzerklärung](https://db.gestaltmatcher.org/doctolib_data_privacy)

Mit meiner Registrierung willige ich ein, dass meine persönlichen Daten zusammen mit den Informationen 
zu meiner Diagnose bzw. der Diagnose meines Kindes auf der GestaltMatcher Plattform gespeichert 
und analysiert werden. 
Meine persönlichen Kontaktdaten sowie die medizinischen Daten 
werden nicht an Dritte weitergegeben und nach Abschluß der Diagnose gelöscht. 
Ich willige ein, dass ich von GestaltMatcher kontaktiert werde, um das Resultat meiner Analyse
zu erhalten.
Diese Einwilligung kann ich jederzeit ohne Angabe von Gründen widerrufen.
`

const theForm = {
  Xmarkdown01: {
    value: infoText
  },
  confirmed: {
    tag: 'boxes',
    label: 'Einverständniserklärung gelesen',
    classname: 'JaNein',
    attributes: {
      type: 'checkbox',
      options: [{
        label: 'Ich habe die Einverständniserklärung verstanden und bin mit der Übertragung, Speicherung und Analyse meiner Daten einverstanden.',
        value: 'yes'
      }]
    },
    validation: {
      required: true,
      minLength: 1
    },
    errorMessage: 'Bitte bestätigen Sie!'
  },
  XlineBreakAA: {},
  dp_confirmed: {
    tag: 'boxes',
    label: 'Datenschutzerklärung gelesen',
    classname: 'JaNein',
    attributes: {
      type: 'checkbox',
      options: [{
        label: 'Ich habe die Datenschutzerklärung sowie die Patienteninformation gelesen und akzeptiert.',
        value: 'yes'
      }]
    },
    validation: {
      required: true,
      minLength: 1
    },
    errorMessage: 'Bitte bestätigen Sie!'
  },
  XlineBreakAB: {},
  caretakers_confirmed: {
    tag: 'boxes',
    label: 'Unterzeichnungsbefugnis',
    classname: 'JaNein',
    attributes: {
      type: 'switch',
      options: [{
        label: 'Ich unterschreibe als Patient/in oder im Namen aller Elternteile bzw. Sorgeberechtigten.',
        value: 'yes'
      }]
    },
    validation: {
      required: true,
      minLength: 1
    },
    errorMessage: 'Bitte bestätigen Sie!'
  },
  XsmallskipX: {},
  Xhrule1: {},
  first_name: {
    tag: 'input',
    label: 'Vorname des Patienten',
    attributes: {
      type: 'text',
      placeholder: 'Vorname',
      style: { width: '300px' }
    },
    validation: {
      required: true,      
    },
    errorMessage: 'Bitte Vornamen eingeben',
    absentValueMessage: 'Bitte Vornamen eingeben',
  },
  name: {
    tag: 'input',
    label: 'Name des Patienten',
    attributes: {
      type: 'text',
      placeholder: 'Name',
      style: { width: '300px' }
    },
    validation: {
      required: true,
    },
    errorMessage: 'Bitte Namen eingeben',
    absentValueMessage: 'Bitte Namen eingeben',
  },
  XlineBreakA0: {},
  email: {
    tag: 'input',
    label: 'Kontakt E-Mail',
    attributes: {
      type: 'email',
      placeholder: 'E-Mail',
      style: { width: '300px' }
    },
    validation: {
      required: true,      
      isEmail: true
    },
    errorMessage: 'Bitte E-Mail eingeben',
    absentValueMessage: 'Bitte E-Mail eingeben',
  },
  phone: {
    tag: 'input',
    label: 'Kontakt Telefon',
    attributes: {
      type: 'text',
      placeholder: 'Telefonnummer',
      style: { width: '300px' }
    },
    validation: {
      required: true,      
    },
    errorMessage: 'Bitte Telefonnummer eingeben',
    absentValueMessage: 'Bitte Telefonnummer eingeben',
  },
  XlineBreakA1: {},
  Xhrule2: {},
  physician_name: {
    tag: 'input',
    label: 'Name Kinderarzt/behandelnder Arzt',
    attributes: {
      type: 'text',
      placeholder: 'Name',
      style: { width: '300px' }
    },
  },
  physician_location: {
    tag: 'input',
    label: 'Adresse Kinderarzt/behandelnder Arzt',
    attributes: {
      type: 'text',
      placeholder: 'Adresse',
      style: { width: '300px' }
    },
  },
  XsmallskipX1: {},
  Xhrule3: {},
  sig_first_name: {
    tag: 'input',
    label: 'Vorname des Unterzeichnenden',
    attributes: {
      type: 'text',
      placeholder: 'Vorname',
      style: { width: '300px' }
    },
    validation: {
      required: true,

    },
    errorMessage: 'Bitte Vornamen eingeben',
    absentValueMessage: 'Bitte Vornamen eingeben',
  },
    sig_name: {
    tag: 'input',
    label: 'Name des Unterzeichnenden',
    attributes: {
      type: 'text',
      placeholder: 'Name',
      style: { width: '300px' }
    },
    validation: {
      required: true,
    },
    errorMessage: 'Bitte Namen eingeben',
    absentValueMessage: 'Bitte Namen eingeben',
  },
  XlineBreakB: {},
  sig_place: {
    tag: 'input',
    label: 'Ort',
    attributes: {
      type: 'text',
      placeholder: 'Ort',
      style: { width: '300px' }
    },
    validation: {
      required: true,
    },
    errorMessage: 'Bitte Ort eingeben',
    absentValueMessage: 'Bitte Ort eingeben'
  },
  sig_date: {
    tag: 'input',
    label: 'Datum',
    attributes: {
      type: 'date'
    }
  },
  sig_img: {
    tag: 'input',
    label: 'Unterschrift',
    attributes: {
      type: 'hidden',
    },
    validation: {
      required: true,
    },
    errorMessage: 'Bitte Einverständniserklärung unterschreiben'
  }
}

const requiredFields = Object.entries(theForm)
  .filter(([_, config]) => config.validation?.required)
  .map(([key]) => key);

const ConsentForm = ({ onValidChange, ...props }) => {
  // const [patState, setPatState] = useState( -1 );
  const formState = useSelector(state => state.forms.forms[FORMLABEL]);
  const dispatch = useDispatch();

  useEffect(() => {
    const valid = formState
      ? requiredFields.every(key => formState.state[key]?.valid)  
      : false;
    onValidChange(valid);
  }, [formState]);

  // @TODO: noch keine sehr elegante Loesung :(
  // useEffect( () => {
  //   let firstName;
  //   let lastName;
  //   let sig;
  //   switch( patState ) {
  //     case 0:
  //       firstName = "Vorname Patientin oder Patient"
  //       lastName = "Nachname Patientin oder Patient"
  //       sig = "Unterschrift Patientin oder Patient"
  //       break;
  //     case 1:
  //       firstName = "Vorname Elternteil"
  //       lastName = "Nachname Elternteil"
  //       sig = "Unterschrift Elternteil"
  //       break;
  //     case 2:
  //       firstName = "Vorname Sorgerechtige oder Sorgeberechtigter"
  //       lastName = "Nachname Sorgerechtige oder Sorgeberechtigter"
  //       sig = "Unterschrift Sorgerechtige oder Sorgeberechtigter"
  //       break;
  //   }
  //   if (patState > -1) {
  //     const firstNameEl = document.getElementById('label_sig_first_name');
  //     const lastNameEl = document.getElementById('label_sig_name');
  //     const sigEl = document.getElementById('label_signature');
  //     if ( firstNameEl ) {
  //       firstNameEl.innerHTML = firstName;
  //     }
  //     if ( lastNameEl ) {
  //       lastNameEl.innerHTML = lastName;
  //     }
  //     if ( sigEl ) {
  //       sigEl.innerHTML = sig;
  //     }
  //   }
  // }, [patState]);


  // const changeHandler = (key, value, valid) => {
    // let firstName = "Vorname Patientin oder Patient"
    // let lastName = "Nachname Patientin oder Patient"
    // switch( +value ) {
    //   case 1:
    //     firstName = "Vorname Elternteil"
    //     lastName = "Nachname Elternteil"
    //     break;
    //   case 2:
    //     firstName = "Vorname Sorgerechtige oder Sorgeberechtigter"
    //     lastName = "Nachname Sorgerechtige oder Sorgeberechtigter"
    //     break;
    // }
    // dispatch( formActions.changeFieldLabel( {
    //   label: FORMLABEL, 
    //   field: 'sig_first_name', 
    //   newLabel: firstName      
    // }))
    // dispatch( formActions.changeFieldLabel( {
    //   label: FORMLABEL, 
    //   field: 'sig_name', 
    //   newLabel: lastName      
    // }))
  //   setPatState( +value );
  // }
  
  const sigChangedHandler = ( data ) => {
    const newElState = {
      ...formState.state.sig_img,
      value: data,
      valid: data !== null,
      touched: true
    }

    dispatch( formActions.changeFormValue({
      label: FORMLABEL, 
      field: 'sig_img', 
      state: newElState
    }));
  }

  return <>

    <p style={{margin: '20px 0', lineHeight: "130%"}}> 

    </p>
    <ReduxForm
      entries={theForm}
      label={FORMLABEL}
    />
    <div style={{ marginLeft: '15px' }}>
      <label id="label_signature" className={formStyles.Label}>Unterschrift</label>
      {(formState 
        && formState.state.confirmed.value.length > 0 
        && formState.state.dp_confirmed.value.length > 0
        && formState.state.caretakers_confirmed.value.length > 0
       )
        ? 
        <Signature onChange={sigChangedHandler} value={formState.state.sig_img.value} />
        : 
        <div className={styles.fakeCanvas} >Bitte Einverständiserklärung als gelesen markieren</div>}
    </div>
  </>
};

export default ConsentForm;

/* <Demo />


*/